import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

firebase.initializeApp({
  apiKey: "AIzaSyDn00k6ba53wRU9uo3GA7pRAfUwSYjbis8",
    authDomain: "spectiv-tv.firebaseapp.com",
    databaseURL: "https://spectiv-tv.firebaseio.com",
    projectId: "spectiv-tv",
    storageBucket: "spectiv-tv.appspot.com",
    messagingSenderId: "945292949292"
})

export default firebase



// WEBPACK FOOTER //
// ./src/js/fb.js